import { Component } from 'react';
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {setClientRepresentative} from '../../../redux/actions/userAction'
import Select from '../../Helpers/react-select-all';
import RaisedButton from 'material-ui/RaisedButton';

class ChooseClient extends Component {

	constructor(props) {
		super(props)
		this.state ={client_id: false}
		this.mapClients = this.mapClients.bind(this);
	}

	mapClients(value, key) {
		return ({value: value.client_id, label: value.client_id + "-"+value.client})
	}

	selectClient(id) {
		this.props.setClientRepresentative(this.props.clientPath + '/api/user/action/setClientRepresentative', id, this.props.user.user_id, this.props.user.user_token, this.props.clientPath)
	}

	getSelectedValue() {
        return this.state.client_id;
    }
	
	setSelectedValue(value) {
		// -- set local state
		this.setState({client_id: value})
	}

	render() {
        return (
            <div>
                 <div className="card__header">
		              <h3>Bij welke klant wilt u inloggen?</h3>
		          </div>
		          <div className="card__body">
					{this.props.user.user_profile.representativeClients ?
						<Select

						simpleValue={true}
						onChange={value => this.setSelectedValue(value)}
						value={this.getSelectedValue()}
						multi={false}
						options={this.props.user.user_profile.representativeClients.map((value, key) => this.mapClients(value, key))}
						/>

						:
					''}
					 <div className="floating__button floating__button--right"><RaisedButton onClick={() => this.selectClient(this.state.client_id)} label="Inloggen" primary={true} fullWidth={true}/></div>
		          </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
  return {
       user: state.UserReducer,
       clientPath: state.ClientPathReducer.clientPath
    }
}

const mapDispatchToProps = (dispatch) => {
  return {
 		 setClientRepresentative: (url, client_id,user_id, user_token, clientPath) => dispatch(setClientRepresentative(url, client_id, user_id, user_token, clientPath)),
    };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ChooseClient));



// WEBPACK FOOTER //
// ./src/components/Application/ChooseClient/index.js